<template>
    <Dialog :dialog="dlg" :dt="dt">

        <template v-slot:filter="{onFocus}">

            <TextField @focus="onFocus" ref="q" dusk="select-search" block max-length="255" placeholder="Zoek..." v-model="dt.filter.q"></TextField>

        </template>

        <template v-slot:item.id_status ="{ item }">
            <span class="cursor-pointer" @click="dlg.open('workorder', item)">            
                <StatusChip :model="item"></StatusChip>
            </span>
        </template>

        <template v-slot:item.invoices ="{ item }">
            <InvoiceList :list="item.invoices"></InvoiceList>
        </template>

        <template v-slot:item.priority="{item}">
            <span class="text-error" v-if="item.priority==1">Hoog</span>
            <span v-else-if="item.priority==2">Normaal</span>
            <span v-else-if="item.priority==3">Laag</span>
        </template>

        <template v-slot:item.rel_phone="{item}">
            <Phone v-if="item.rel_phone" v-model="item.rel_phone"></Phone>
            <span class="mx-1" v-if="item.rel_phone&&item.rel_mobile">|</span>
            <Phone v-if="item.rel_mobile" v-model="item.rel_mobile"></Phone>
        </template>

        <template v-slot:item.prs_phone="{item}">
            <Phone v-if="item.prs_phone" v-model="item.prs_phone"></Phone>
            <span class="mx-1" v-if="item.prs_phone&&item.prs_mobile">|</span>
            <Phone v-if="item.prs_mobile" v-model="item.prs_mobile"></Phone>
        </template>

        <template v-slot:item.inv_number="{item}">
            <span v-if="!item.id_invoice"></span>
            <span v-else-if="item.inv_number">{{item.inv_number}}</span>
            <span v-else>Concept</span>
        </template>



    </Dialog>
</template>



<script setup>

    import useDataTable from '@app/useDataTableSelectList'
    import TextField from '@controls/input/TextField'
    import Dialog from '@shared/ui/dialogs/SelectListDialog'
    import { workorders as api } from '@app/api'
    import string from '@lib/string'
    import { ref } from 'vue'
    import clsDialog from '@cls/clsSelectListDialog'
    import feature from '@app/features'
    import StatusChip from '@/features/workorders/workorder/controls/StatusChip.vue'
    import Phone from "@controls/text/Phone.vue";
    import InvoiceList from '@/features/workorders/workorder/controls/InvoiceList'

    const q = ref(null)

    var headers = [
        { type: 'cmd'},
        { type: 'flag'},
        { type: 'note'},

        { text: "Status"                , value: "id_status",                  },
        { text: "Nummer"                , value: "number",                  type: 'open', action: 'workorder.open'},
        { text: "Title"                 , value: "title",                   type: 'open', action: 'workorder.open'},
        { text: "Code"                  , value: "typecode",                },
        { visible: false, text: "Type"                  , value: "type",                    },
        { visible: false, text: "Project nummer"         , value: "pro_number",                  },
        { visible: false, text: "Project naam"           , value: "pro_name",                  },
        { visible: false, text: "Project referentie"      , value: "pro_reference",                  },
        { visible: false, text: "Factuur"               , value: "invoices",              },
        { visible: false,text: "Planning door"         , value: "can_employee_pickup",     fmt: (v,V,item) => v=='no' ? "Kantoor" : "Medewerkers"},        
        { visible: false, text: "Doeldatum"             , value: "target_at",              type: 'date'},
        { visible: false, text: "Urenschatting"         , value: "estimate", type: 'hhmm'},
        { visible: false, text: "Prioriteit"            , value: "priority",                },
        { text: "Relatie"               , value: "rel_name",                },
        { visible: false,text: "Relatie telefoon"      , value: "rel_phone",               },
        { visible: false,text: "Relatie email"         , value: "rel_email",               type:'email'},
        { text: "Adres"                 , value: "adr_street",              fmt: (v, V, item) => string.concat(' ', item.adr_street, item.adr_street_number)},
        { visible: false,text: "Postcode"              , value: "adr_zipcode",                 },
        { text: "Plaats"                , value: "adr_city",                },
        { text: "Contactpersoon"        , value: "firstname",               fmt: (v, V, item) => string.concat(' ', item.prs_firstname, item.prs_infix, item.prs_lastname)},
        { visible: false,text: "Contact email"         , value: "prs_email",               type: 'email'},
        { visible: false,text: "Contact telefoon"      , value: "prs_phone",               },
//        { text: "Factuur"               , value: "inv_number",              },
//        { text: "Factuurbedrag"         , value: "inv_total",               type:'amount'},

        { isUtc: true, text: "Gewijzigd",                value: "updated_at",    type: 'datetime',   visible: false},
		{ text: "Gewijzigd door",           value: "updated_by",                        visible: false},
		{ isUtc: true, text: "Aangemaakt",               value: "created_at",    type: 'datetime',   visible: false},
		{ text: "Aangemaakt door",          value: "created_by",                        visible: false},
    ]

//    if(!feature.canProject) { headers = headers.filter( (line) => line.value != 'pro_number'); }
//    if(!feature.canProject) { headers = headers.filter( (line) => line.value != 'pro_name'); }
//    if(!feature.canProject) { headers = headers.filter( (line) => line.value != 'pro_reference'); }

    var dt = useDataTable("dt_selectworkorder", "workorder", api, headers, {
        actionDblClick:null,
        itemName: {
            prefix: 'de',
            single: 'werkbon',
            plural: 'werkbonnen',
        }, 
        useCommandPane: false,
        canArchive: false,
        filter: {
            type: '',
            selectfor: '',
        }
    })

    let dlg = ref(
        new clsDialog("select_workorder", "Selecteer werkbon", dt, {
            multiselect: false, 
            maxWidth:"1200px",
            defaultFocus: ()=>q.value
        })).value;

</script>
